@for (bank of banks; let i = $index; track bank) {
  <div (click)="selectBank(bank)" class="flex flex-col mb-4 cursor-pointer min-w-full flex-grow-1">
    <div class="flex flex-row">
      <div class="flex flex-1 items-center">
        <img [src]="bank.logo" class="w-8 h-8 mr-3 rounded-full" />
        <span class="text-secondary font-bold text-sm">{{ bank.name }}</span>
      </div>
      <img class="mr-2 w-4 h-4 place-self-center" src="../../../../../assets/images/svg/see-more-arrow.svg" />
    </div>
    @if (i < banks.length - 1) {
      <div class="mt-4 h-[1px] bg-gray-300"></div>
    }
  </div>
}
